import { render } from "./colorOption.vue?vue&type=template&id=7511d48c&scoped=true"
import script from "./colorOption.vue?vue&type=script&lang=js"
export * from "./colorOption.vue?vue&type=script&lang=js"

import "./colorOption.vue?vue&type=style&index=0&id=7511d48c&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7511d48c"]])

export default __exports__